import React from 'react';
import AuthGuard from './components/auth/AuthGuard';
import Header from './components/common/Header';
import Dashboard from './components/Dashboard';
import './App.css';

function App() {
  return (
    <div className="App">
      <AuthGuard>
        <Header />
        <Dashboard />
      </AuthGuard>
    </div>
  );
}

export default App;